import type { IVariable } from "@bbj-types/utils";
import { Box, Typography } from "@mui/material";
import { EditorV2 } from "@styleguide";
import { type Control, Controller } from "react-hook-form";
import type { TEmailForm } from "./resolver";

export interface IEmailContentProps {
  control: Control<TEmailForm, void>;
  variables: IVariable[];
  contentMaxHeight?: number;
}

export const EmailContent = ({ control, variables, contentMaxHeight = 210 }: IEmailContentProps) => {
  return (
    <Controller
      control={control}
      name="content"
      render={({ field: { value, onChange }, fieldState: { error } }) => (
        <Box
          sx={{
            height: contentMaxHeight,
          }}
        >
          <EditorV2
            variableList={variables}
            value={value}
            onChange={onChange}
            excludePlugins={["autoresize"]}
            init={{
              // biome-ignore lint/style/useNamingConvention: <explanation>
              max_height: contentMaxHeight,
            }}
          />
          {error?.message && (
            <Typography
              sx={[
                {
                  ml: 2,
                },
                (theme) => ({ color: theme.palette.error.main }),
              ]}
            >
              {error.message}
            </Typography>
          )}
        </Box>
      )}
    />
  );
};
